module.exports = __webpack_public_path__ + "img/Sedan_Side_Right.e9bc5b65.svg";